import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { FollowUpApplicationForm } from '@/follow-up-applications/FollowUpApplicationForm';

/**
 * The public Follow-Up Partner Application form. How it differs from the
 * coordinator form is in `follow-up-applications/roles.ts`.
 *
 * On `useAuthCheck`'s public-page list for the same reason as the coordinator
 * route. Not the coordinators' Add Partner form: that creates an unverified
 * partner linked to its coordinator, while an approved application creates a
 * verified partner with no creator and no network edge.
 */
export const Route = createFileRoute('/follow-up-partner-application')({
  component: FollowUpPartnerApplicationPage,
  beforeLoad: () => {
    return {
      pageBackground: 'white',
      noContainer: true,
    };
  },
});

function FollowUpPartnerApplicationPage(): ReactElement {
  return <FollowUpApplicationForm applicationRole="partner" />;
}
